import type { IconProps } from '../types';

const Search = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M14.006 23.563a10.072 10.072 0 0 0 5.919-1.92l5.981 5.844L28 25.437l-5.967-5.859a9.643 9.643 0 0 0 1.937-6.132 9.668 9.668 0 0 0-2.361-5.987 10.032 10.032 0 0 0-5.643-3.265 10.176 10.176 0 0 0-6.494.863 9.876 9.876 0 0 0-4.55 4.62 9.597 9.597 0 0 0-.646 6.387 9.763 9.763 0 0 0 3.535 5.404 10.123 10.123 0 0 0 6.195 2.095Zm0-16.665c1.39 0 2.749.404 3.905 1.16a6.917 6.917 0 0 1 2.588 3.09 6.752 6.752 0 0 1 .4 3.976 6.84 6.84 0 0 1-1.923 3.525 7.076 7.076 0 0 1-3.599 1.884 7.166 7.166 0 0 1-4.06-.392 7 7 0 0 1-3.155-2.535 6.783 6.783 0 0 1-1.185-3.824c0-1.826.74-3.577 2.059-4.868a7.105 7.105 0 0 1 4.97-2.016Z" />
  </svg>
);

export default Search;
